/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedHandoversRouteImport } from './routes/_authed/handovers'
import { Route as AuthedPendingActivationRouteImport } from './routes/_authed/pending-activation'
import { Route as AuthedAuditMasterDataRouteImport } from './routes/_authed/audit.master-data'
import { Route as AuthedAuditUserManagementRouteImport } from './routes/_authed/audit.user-management'
import { Route as AuthedMasterTypesIndexRouteImport } from './routes/_authed/master-types.index'
import { Route as AuthedMasterTypesNewRouteImport } from './routes/_authed/master-types.new'
import { Route as AuthedRecordsIndexRouteImport } from './routes/_authed/records.index'
import { Route as AuthedSubmissionsIndexRouteImport } from './routes/_authed/submissions.index'
import { Route as AuthedSubmissionsSubmissionIdRouteImport } from './routes/_authed/submissions.$submissionId'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users.index'
import { Route as AuthedMasterTypesCodeSchemaRouteImport } from './routes/_authed/master-types.$code.schema'
import { Route as AuthedRecordsCodeIndexRouteImport } from './routes/_authed/records.$code.index'
import { Route as AuthedRecordsCodeNewRouteImport } from './routes/_authed/records.$code.new'
import { Route as AuthedRecordsCodeRecordIdIndexRouteImport } from './routes/_authed/records.$code.$recordId.index'
import { Route as AuthedRecordsCodeRecordIdEditRouteImport } from './routes/_authed/records.$code.$recordId.edit'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHandoversRoute = AuthedHandoversRouteImport.update({
  id: '/handovers',
  path: '/handovers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPendingActivationRoute = AuthedPendingActivationRouteImport.update({
  id: '/pending-activation',
  path: '/pending-activation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditMasterDataRoute = AuthedAuditMasterDataRouteImport.update({
  id: '/audit/master-data',
  path: '/audit/master-data',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditUserManagementRoute =
  AuthedAuditUserManagementRouteImport.update({
    id: '/audit/user-management',
    path: '/audit/user-management',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedMasterTypesIndexRoute = AuthedMasterTypesIndexRouteImport.update({
  id: '/master-types/',
  path: '/master-types/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMasterTypesNewRoute = AuthedMasterTypesNewRouteImport.update({
  id: '/master-types/new',
  path: '/master-types/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecordsIndexRoute = AuthedRecordsIndexRouteImport.update({
  id: '/records/',
  path: '/records/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSubmissionsIndexRoute = AuthedSubmissionsIndexRouteImport.update({
  id: '/submissions/',
  path: '/submissions/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSubmissionsSubmissionIdRoute =
  AuthedSubmissionsSubmissionIdRouteImport.update({
    id: '/submissions/$submissionId',
    path: '/submissions/$submissionId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMasterTypesCodeSchemaRoute =
  AuthedMasterTypesCodeSchemaRouteImport.update({
    id: '/master-types/$code/schema',
    path: '/master-types/$code/schema',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecordsCodeIndexRoute = AuthedRecordsCodeIndexRouteImport.update({
  id: '/records/$code/',
  path: '/records/$code/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecordsCodeNewRoute = AuthedRecordsCodeNewRouteImport.update({
  id: '/records/$code/new',
  path: '/records/$code/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRecordsCodeRecordIdIndexRoute =
  AuthedRecordsCodeRecordIdIndexRouteImport.update({
    id: '/records/$code/$recordId/',
    path: '/records/$code/$recordId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedRecordsCodeRecordIdEditRoute =
  AuthedRecordsCodeRecordIdEditRouteImport.update({
    id: '/records/$code/$recordId/edit',
    path: '/records/$code/$recordId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/handovers': typeof AuthedHandoversRoute
  '/pending-activation': typeof AuthedPendingActivationRoute
  '/audit/master-data': typeof AuthedAuditMasterDataRoute
  '/audit/user-management': typeof AuthedAuditUserManagementRoute
  '/master-types/new': typeof AuthedMasterTypesNewRoute
  '/submissions/$submissionId': typeof AuthedSubmissionsSubmissionIdRoute
  '/master-types/': typeof AuthedMasterTypesIndexRoute
  '/records/': typeof AuthedRecordsIndexRoute
  '/submissions/': typeof AuthedSubmissionsIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
  '/master-types/$code/schema': typeof AuthedMasterTypesCodeSchemaRoute
  '/records/$code/new': typeof AuthedRecordsCodeNewRoute
  '/records/$code/': typeof AuthedRecordsCodeIndexRoute
  '/records/$code/$recordId/edit': typeof AuthedRecordsCodeRecordIdEditRoute
  '/records/$code/$recordId/': typeof AuthedRecordsCodeRecordIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/handovers': typeof AuthedHandoversRoute
  '/pending-activation': typeof AuthedPendingActivationRoute
  '/': typeof AuthedIndexRoute
  '/audit/master-data': typeof AuthedAuditMasterDataRoute
  '/audit/user-management': typeof AuthedAuditUserManagementRoute
  '/master-types/new': typeof AuthedMasterTypesNewRoute
  '/submissions/$submissionId': typeof AuthedSubmissionsSubmissionIdRoute
  '/master-types': typeof AuthedMasterTypesIndexRoute
  '/records': typeof AuthedRecordsIndexRoute
  '/submissions': typeof AuthedSubmissionsIndexRoute
  '/users': typeof AuthedUsersIndexRoute
  '/master-types/$code/schema': typeof AuthedMasterTypesCodeSchemaRoute
  '/records/$code/new': typeof AuthedRecordsCodeNewRoute
  '/records/$code': typeof AuthedRecordsCodeIndexRoute
  '/records/$code/$recordId/edit': typeof AuthedRecordsCodeRecordIdEditRoute
  '/records/$code/$recordId': typeof AuthedRecordsCodeRecordIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/handovers': typeof AuthedHandoversRoute
  '/_authed/pending-activation': typeof AuthedPendingActivationRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/audit/master-data': typeof AuthedAuditMasterDataRoute
  '/_authed/audit/user-management': typeof AuthedAuditUserManagementRoute
  '/_authed/master-types/new': typeof AuthedMasterTypesNewRoute
  '/_authed/submissions/$submissionId': typeof AuthedSubmissionsSubmissionIdRoute
  '/_authed/master-types/': typeof AuthedMasterTypesIndexRoute
  '/_authed/records/': typeof AuthedRecordsIndexRoute
  '/_authed/submissions/': typeof AuthedSubmissionsIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
  '/_authed/master-types/$code/schema': typeof AuthedMasterTypesCodeSchemaRoute
  '/_authed/records/$code/new': typeof AuthedRecordsCodeNewRoute
  '/_authed/records/$code/': typeof AuthedRecordsCodeIndexRoute
  '/_authed/records/$code/$recordId/edit': typeof AuthedRecordsCodeRecordIdEditRoute
  '/_authed/records/$code/$recordId/': typeof AuthedRecordsCodeRecordIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/handovers'
    | '/pending-activation'
    | '/audit/master-data'
    | '/audit/user-management'
    | '/master-types/new'
    | '/submissions/$submissionId'
    | '/master-types/'
    | '/records/'
    | '/submissions/'
    | '/users/'
    | '/master-types/$code/schema'
    | '/records/$code/new'
    | '/records/$code/'
    | '/records/$code/$recordId/edit'
    | '/records/$code/$recordId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/handovers'
    | '/pending-activation'
    | '/'
    | '/audit/master-data'
    | '/audit/user-management'
    | '/master-types/new'
    | '/submissions/$submissionId'
    | '/master-types'
    | '/records'
    | '/submissions'
    | '/users'
    | '/master-types/$code/schema'
    | '/records/$code/new'
    | '/records/$code'
    | '/records/$code/$recordId/edit'
    | '/records/$code/$recordId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/handovers'
    | '/_authed/pending-activation'
    | '/_authed/'
    | '/_authed/audit/master-data'
    | '/_authed/audit/user-management'
    | '/_authed/master-types/new'
    | '/_authed/submissions/$submissionId'
    | '/_authed/master-types/'
    | '/_authed/records/'
    | '/_authed/submissions/'
    | '/_authed/users/'
    | '/_authed/master-types/$code/schema'
    | '/_authed/records/$code/new'
    | '/_authed/records/$code/'
    | '/_authed/records/$code/$recordId/edit'
    | '/_authed/records/$code/$recordId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/handovers': {
      id: '/_authed/handovers'
      path: '/handovers'
      fullPath: '/handovers'
      preLoaderRoute: typeof AuthedHandoversRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pending-activation': {
      id: '/_authed/pending-activation'
      path: '/pending-activation'
      fullPath: '/pending-activation'
      preLoaderRoute: typeof AuthedPendingActivationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit/master-data': {
      id: '/_authed/audit/master-data'
      path: '/audit/master-data'
      fullPath: '/audit/master-data'
      preLoaderRoute: typeof AuthedAuditMasterDataRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit/user-management': {
      id: '/_authed/audit/user-management'
      path: '/audit/user-management'
      fullPath: '/audit/user-management'
      preLoaderRoute: typeof AuthedAuditUserManagementRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/master-types/': {
      id: '/_authed/master-types/'
      path: '/master-types'
      fullPath: '/master-types/'
      preLoaderRoute: typeof AuthedMasterTypesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/master-types/new': {
      id: '/_authed/master-types/new'
      path: '/master-types/new'
      fullPath: '/master-types/new'
      preLoaderRoute: typeof AuthedMasterTypesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/records/': {
      id: '/_authed/records/'
      path: '/records'
      fullPath: '/records/'
      preLoaderRoute: typeof AuthedRecordsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/submissions/': {
      id: '/_authed/submissions/'
      path: '/submissions'
      fullPath: '/submissions/'
      preLoaderRoute: typeof AuthedSubmissionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/submissions/$submissionId': {
      id: '/_authed/submissions/$submissionId'
      path: '/submissions/$submissionId'
      fullPath: '/submissions/$submissionId'
      preLoaderRoute: typeof AuthedSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/master-types/$code/schema': {
      id: '/_authed/master-types/$code/schema'
      path: '/master-types/$code/schema'
      fullPath: '/master-types/$code/schema'
      preLoaderRoute: typeof AuthedMasterTypesCodeSchemaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/records/$code/': {
      id: '/_authed/records/$code/'
      path: '/records/$code'
      fullPath: '/records/$code/'
      preLoaderRoute: typeof AuthedRecordsCodeIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/records/$code/new': {
      id: '/_authed/records/$code/new'
      path: '/records/$code/new'
      fullPath: '/records/$code/new'
      preLoaderRoute: typeof AuthedRecordsCodeNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/records/$code/$recordId/': {
      id: '/_authed/records/$code/$recordId/'
      path: '/records/$code/$recordId'
      fullPath: '/records/$code/$recordId/'
      preLoaderRoute: typeof AuthedRecordsCodeRecordIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/records/$code/$recordId/edit': {
      id: '/_authed/records/$code/$recordId/edit'
      path: '/records/$code/$recordId/edit'
      fullPath: '/records/$code/$recordId/edit'
      preLoaderRoute: typeof AuthedRecordsCodeRecordIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedHandoversRoute: typeof AuthedHandoversRoute
  AuthedPendingActivationRoute: typeof AuthedPendingActivationRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAuditMasterDataRoute: typeof AuthedAuditMasterDataRoute
  AuthedAuditUserManagementRoute: typeof AuthedAuditUserManagementRoute
  AuthedMasterTypesNewRoute: typeof AuthedMasterTypesNewRoute
  AuthedSubmissionsSubmissionIdRoute: typeof AuthedSubmissionsSubmissionIdRoute
  AuthedMasterTypesIndexRoute: typeof AuthedMasterTypesIndexRoute
  AuthedRecordsIndexRoute: typeof AuthedRecordsIndexRoute
  AuthedSubmissionsIndexRoute: typeof AuthedSubmissionsIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
  AuthedMasterTypesCodeSchemaRoute: typeof AuthedMasterTypesCodeSchemaRoute
  AuthedRecordsCodeNewRoute: typeof AuthedRecordsCodeNewRoute
  AuthedRecordsCodeIndexRoute: typeof AuthedRecordsCodeIndexRoute
  AuthedRecordsCodeRecordIdEditRoute: typeof AuthedRecordsCodeRecordIdEditRoute
  AuthedRecordsCodeRecordIdIndexRoute: typeof AuthedRecordsCodeRecordIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedHandoversRoute: AuthedHandoversRoute,
  AuthedPendingActivationRoute: AuthedPendingActivationRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAuditMasterDataRoute: AuthedAuditMasterDataRoute,
  AuthedAuditUserManagementRoute: AuthedAuditUserManagementRoute,
  AuthedMasterTypesNewRoute: AuthedMasterTypesNewRoute,
  AuthedSubmissionsSubmissionIdRoute: AuthedSubmissionsSubmissionIdRoute,
  AuthedMasterTypesIndexRoute: AuthedMasterTypesIndexRoute,
  AuthedRecordsIndexRoute: AuthedRecordsIndexRoute,
  AuthedSubmissionsIndexRoute: AuthedSubmissionsIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
  AuthedMasterTypesCodeSchemaRoute: AuthedMasterTypesCodeSchemaRoute,
  AuthedRecordsCodeNewRoute: AuthedRecordsCodeNewRoute,
  AuthedRecordsCodeIndexRoute: AuthedRecordsCodeIndexRoute,
  AuthedRecordsCodeRecordIdEditRoute: AuthedRecordsCodeRecordIdEditRoute,
  AuthedRecordsCodeRecordIdIndexRoute: AuthedRecordsCodeRecordIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
